import script from "./ADLFormNumMini.vue?vue&type=script&setup=true&lang=js"
export * from "./ADLFormNumMini.vue?vue&type=script&setup=true&lang=js"

import "./ADLFormNumMini.vue?vue&type=style&index=0&id=0919b65b&lang=less&scoped=true"

import exportComponent from "D:\\A-Project\\nezha_business\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0919b65b"]])

export default __exports__